import { useEffect, useState, useRef } from 'react';
import { post, get } from '../../services/api';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { TailSpin } from "react-loader-spinner";
import { Link } from 'react-router-dom';

import AdminSection from '../AdminSection/AdminSection';
import AdminTable from "../AdminTable/AdminTable";

import { Pencil, Trash, ArrowLeft } from "@phosphor-icons/react";

import '../ListarCluster/listarCluster.css';

export default function EditarCluster( {setNotifier} ) {
    
    const authToken = localStorage.getItem('adminToken');

    const [clusters, setClusters] = useState([]);
    const [salvarDescricao, setSalvarDescricao] = useState('');
    const [isFetchingSalvarCluster, setIsFetchingSalvarCluster] = useState(false);
    const [ dados, setDados ] = useState([]);
    const [apareceEditar, setApareceEditar] = useState({});
    const [currentClusterId, setCurrentClusterId] = useState(null);
    const inputRef = useRef(null);

    
    const tableData = {
        atributoKey: 'id_cluster',
        colunas: [
            { nome: '', atributo: '', style: {width: '72px'} },
            { nome: 'Descrição', atributo: 'descricao' },
            { nome: 'Ação', atributo: 'acao', style: {width: '120px'}}
        ],
        dados: dados
    };

    
    useEffect(() => {
        popularDadosTabela();
    }, [ clusters, apareceEditar]);

    async function getClusters() {
        try {

            const response = await get('/admin/cluster/getnomeclusters', {}, authToken);

            setClusters(response);
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function salvarCluster() {
        try {
            const requisicao = { descricao: salvarDescricao, cluster: currentClusterId };

            setIsFetchingSalvarCluster(true);
            let response;

            if (salvarDescricao) {

                response = await post('/admin/cluster/salvarnomecluster', requisicao, authToken);
                
                setNotifier(true, 'Cluster salvo com sucesso!');
            } else {
                setNotifier(false, 'Por favor, preencha o campo de descrição!');
                setIsFetchingSalvarCluster(false);
                return;
            }

            setIsFetchingSalvarCluster(false);

            cancelarEdicaoCluster(currentClusterId);
            setSalvarDescricao('');
            getClusters();
            return response;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const confirmarExclusao = (idcluster) => {
        withReactContent(Swal).fire({
            title: <i>Deseja excluir?</i>,
            html: 'O cluster será deletado permanentemente!',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: "red",
        }).then((result) => {
            if (result.isConfirmed) {
                deletarCluster(idcluster);
            }
        });
    };

    async function deletarCluster(idcluster) {
        try {
            const requisicao = { idcluster: idcluster };
            const response = await post('/admin/cluster/deletarcluster', requisicao, authToken);


            setNotifier(true, 'Cluster deletado com sucesso!');
            getClusters();
            return response;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    };

    const editarCluster = (descricao, id_cluster) => {
        setSalvarDescricao(descricao);
        setApareceEditar((prev) => {
            const apareceEditarNovo = {};
            Object.keys(prev).forEach(key => {
            apareceEditarNovo[key] = false;
            });
            apareceEditarNovo[id_cluster] = true;
            return apareceEditarNovo;
        });
        setCurrentClusterId(id_cluster);
        if (inputRef.current) {
            inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" }); 
        }
    };  

    const cancelarEdicaoCluster = (idcluster) => {
        setSalvarDescricao('');
        setCurrentClusterId(null);
        setApareceEditar((prev) => ({
            ...prev,
            [idcluster]: false,
        }));
    };
    
    function popularDadosTabela() {
        if(typeof clusters !== 'undefined' && clusters !== null) {
            setDados(clusters.map((cluster, index) => {

                const row = {   
    
                    descricao: cluster.descricao,
    
                    acao:   <div className='acao-editar-cluster-wrapper'>
                                <button
                                className={`acao-editar-cluster ${!apareceEditar[cluster.id_cluster] ? 'visible' : ''}`}
                                to="/admin/cluster/gerenciarcluster"
                                onClick={() => editarCluster(cluster.descricao, cluster.id_cluster)}
                                >
                                <Pencil />
                                </button>
                                <button className='acao-deletar-cluster' onClick={() => confirmarExclusao(cluster.id_cluster)}>
                                <Trash />
                                </button>
                            </div>,

                            

                }
    
                return row;
            }));
        }
    }

    useEffect(() => {
        getClusters();
    }, []);


    return <>
        <AdminSection 
            etapa={1} titulo={currentClusterId ? 'Editar Cluster' : 'Criar novo cluster'}
        >
            <div className='animal-first-values'>
                <div className='first-values-right'>
                    <div className='id_cluster-wrapper'>
                        <label style={{fontSize: 'larger'}} htmlFor="id_cluster">Informe o cluster</label>
                        <div className='input-button-editar'>
                            <input placeholder='Nome do Cluster' type="text" value={salvarDescricao} onChange={e => setSalvarDescricao(e.currentTarget.value)} required  ref={inputRef}/>
                            <button className="load-metas-btn" style={{marginTop: '0px'}} onClick={() => salvarCluster()}>
                            {isFetchingSalvarCluster ? (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <TailSpin color="#ffffff" height={20} width={39} />
                                </div>
                            )
                                :
                                (
                                    "Salvar"
                                )}
                            </button> 
                            { currentClusterId && <button className='cancelar-edicao-cluster' onClick={() => cancelarEdicaoCluster(currentClusterId)}>
                                Cancelar
                            </button> }
                        </div>
                    </div>
                </div>
            </div>
            
        </AdminSection>
        <AdminSection
            etapa={2} titulo={"Gerenciar Cluster"}
        >
              
            <div className='tabela-gerenciar-cluster'>
                <AdminTable
                    atributoKey={tableData.atributoKey}
                    colunas={tableData.colunas}
                    dados={tableData.dados}
                    styleName={'tabela-habilitar-regioes'}
                />
            </div>

            <div className='voltar-gerenciamento-wrapper'>
                <Link className='voltar-gerenciamento' to='/admin/cluster/gerenciarcluster'><ArrowLeft/>Voltar gerenciamento</Link>
            </div>
        </AdminSection>
    </>
}